<template>
  <section class="article-section">
    <div class="article-info">
      <span class="category">
        {{ article.category.title }}
      </span>
      <p class="article-date">
        {{ article.published_at }} &#183; {{ article.read_time }}
      </p>
    </div>
    <h1 class="main-title">{{ article.title }}</h1>
    <p class="main-subtitle">{{ article.description }}</p>
    <div
      v-if="article.authors.length"
      class="authors"
    >
      <div
        v-for="author in article.authors"
        :key="author.id"
      >
        <img
          v-if="author.image"
          :src="authorImage(author.image)"
          :alt="author.name"
          width="200"
        />
        <p>{{ author.name }}</p>
      </div>
    </div>
    <!-- eslint-disable vue/no-v-html -->
    <div
      id="post"
      v-highlight
      class="article-content"
      v-html="article.content"
    ></div>
  </section>
</template>

<script>
import cloudinaryImage from '~/utils/helpers/cloudinaryImage';

export default {
  directives: {
    async highlight(el) {
      const blocks = el.querySelectorAll('pre code');
      if (blocks.length) {
        const { HighlightJS } = await import('highlight.js');
        await import('highlight.js/scss/xcode.scss');
        blocks.forEach((block) => {
          HighlightJS.highlightElement(block);
        });
        HighlightJS.configure({ ignoreUnescapedHTML: true });
      }
    },
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  methods: {
    authorImage(image) {
      return image
        ? cloudinaryImage({
            imagePath: image,
            width: 100,
            height: 100,
            crop: 'c_fill',
            faceRecognition: true,
          })
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './ArticleSection.scss';
</style>
